
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/glossary",
      function () {
        return require("private-next-pages/docs/transfer/glossary.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/glossary"])
      });
    }
  